"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UELogoSvg = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const imageWhite = "https://cdn2.unrealengine.com/ue-logo-white-e34b6ba9383f.svg";
const imageBlack = "https://cdn2.unrealengine.com/ue-logo-black-97b78ca87386.svg";
const Styled = styled_components_1.default.div `
	height: 36px;
	width: 36px;
	margin: 0 auto;
	svg path {
		transition: fill 0.3s ${(p) => p.theme.easing};
	}

	&.hover {
		&.inline .ue-logo {
			&:hover {
				background: unset;
				path {
					fill: ${(p) => p.theme.palette.accent.text};
				}
			}
		}
		.ue-logo {
			&:hover {
				background: ${(p) => p.theme.palette.accent.text};
			}
		}
	}

	&.hover .ue-logo {
		&:hover {
			background: ${(p) => p.theme.palette.accent.text};
		}
	}

	.ue-logo {
		height: 100%;
		width: 100%;
		transition: background 0.3s ${(p) => p.theme.easing};
		mask: url(${(p) => p.$ueImg});

		&.white {
			mask-size: cover;
			mask-repeat: no-repeat;
			background: #fff;
		}
		&.black {
			mask-size: cover;
			mask-repeat: no-repeat;
			background: #000;
		}
		&.custom {
			mask-size: cover;
			mask-repeat: no-repeat;
			background: #fff;
		}
	}
`;
const UELogoSvg = ({ variant = "white", label, fill = "#fff", ueImg, hoverStyles = true, }) => {
    let el = (react_1.default.createElement("svg", { "aria-label": label, className: "ue-logo", width: "36", height: "36", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
        react_1.default.createElement("path", { fill: fill, fillRule: "evenodd", clipRule: "evenodd", 
            // eslint-disable-next-line max-len
            d: "M33.4787 24.025C33.1168 25.7713 31.5071 30.2502 26.3714 32.6764L24.3096 30.3571L20.83 33.8534C18.6008 33.847 13.9558 33.0589 10.6745 28.6443C10.6745 28.6443 11.3261 28.8504 11.8116 28.8594C12.3808 28.8697 12.9989 28.6611 12.9989 27.7042V18.2647C13.0608 17.4805 12.3061 16.4206 11.0441 16.7091C9.43305 17.0774 8.14655 21.0966 8.14655 21.0966C8.14269 16.2416 10.6371 12.9359 12.5714 11.3017C14.9744 9.26952 17.3169 8.57154 19.0979 8.2908C17.3401 9.29399 16.3511 10.9282 16.3511 12.2984C16.3511 14.5005 17.6801 14.2391 18.0741 13.9146V26.6534C18.0741 26.6534 18.1527 26.8582 18.3355 27.1016C18.6008 27.4531 19.0863 27.8832 19.8732 27.8832C21.2047 27.8832 22.9317 26.3637 22.9317 26.3637V16.0497C22.9317 15.0002 22.1397 13.7343 21.349 13.299C21.349 13.299 22.8145 13.035 23.9477 13.9056C24.1924 13.6081 24.4229 13.3583 24.6238 13.1612C27.2586 10.5715 29.7467 9.83744 31.8174 9.46398H31.82C31.82 9.46398 28.0506 12.4233 28.0506 16.3923C28.0506 19.3452 28.1266 26.5452 28.1266 26.5452C29.5239 27.8974 31.6011 25.9477 33.4787 24.025Z" }),
        react_1.default.createElement("path", { fill: fill, fillRule: "evenodd", clipRule: "evenodd", 
            // eslint-disable-next-line max-len
            d: "M21 41C32.0457 41 41 32.0457 41 21C41 9.9543 32.0457 1 21 1C9.9543 1 1 9.9543 1 21C1 32.0457 9.9543 41 21 41ZM21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z" })));
    let image = ueImg;
    if (image) {
        el = react_1.default.createElement("div", { className: "ue-logo custom", "aria-label": label });
    }
    else if (variant === "black") {
        image = imageBlack;
        el = react_1.default.createElement("div", { className: "ue-logo black", "aria-label": label });
    }
    else if (variant === "white") {
        image = imageWhite;
        el = react_1.default.createElement("div", { className: "ue-logo white", "aria-label": label });
    }
    return (react_1.default.createElement(Styled, { "$ueImg": image || imageWhite, className: `ue-logo-wrap ${variant} ${hoverStyles ? "hover" : ""}` }, el));
};
exports.UELogoSvg = UELogoSvg;
//# sourceMappingURL=UELogoSvg.js.map